module.exports = __webpack_public_path__ + "static/logo-8c8d850ed79343ecb0bd9d9dceca6e06.svg";